

import { authenticate } from '../services';
import * as screens from '../screens';
import Redirections from '../constants/routes';
import * as services from '../services';

const pages = [
  

  // --------------
  // MAIN

  //>>    /
  {
    pagePath: Redirections.ROUTE_LINK_HOME.partial,
    pageComponent: screens.Home,
    PageType: authenticate.PublicRoute   
  },

  //>>    /privacy
  {
    pagePath: Redirections.ROUTE_LINK_PRIVACY_POLICY.partial,
    pageComponent: screens.Privacy,
    PageType: authenticate.PublicRoute   
  },

  //>>    /terms
  {
    pagePath: Redirections.ROUTE_LINK_TERMS.partial,
    pageComponent: screens.Terms,
    PageType: authenticate.PublicRoute   
  },

]

export default pages;
